import { apiGet, API_URI } from './index';

const competitor = {
   getAll: async (projectId: number) => {
      const data = await apiGet(`${API_URI}/api/competitor/getall?projectId=${projectId}`);
      return data;
   }
}

export default competitor; 